export default "__VITE_ASSET__3TPnOVfO__"